import { teleAppoinmentDispatcher } from '..';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const teleAppoinmentReducer = teleAppoinmentDispatcher(initialState, {
  [teleAppoinmentDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [teleAppoinmentDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  }),
  [teleAppoinmentDispatcher.resetData]: (state, _) => ({
    ...initialState
  })
});

export default teleAppoinmentReducer;
